export const settingsConstants = {
    CHANGE_LOCALE: 'CHANGE_LOCALE',
    UPDATE_CURRENT_VENDOR: 'UPDATE_CURRENT_VENDOR',
};